/**
 * Constants for Price Update module
 * Centralized configuration values for better maintainability
 */

// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const ROWS_PER_PAGE = 20;

// Time filters
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

// UI Breakpoints
export const MOBILE_BREAKPOINT = 768;

// Toast Configuration
export const TOAST_CONFIG = {
  position: "top-center",
  autoClose: 500,
};

// Validation Messages
export const VALIDATION_MESSAGES = {
  OFFER_EXCEEDS_PRICE: "Offer price cannot be greater than price",
  NO_CHANGES: "No valid price changes to update.",
  FIX_ERRORS: "Please fix all price validation errors before submitting.",
};

// Success Messages
export const SUCCESS_MESSAGES = {
  PRICES_UPDATED: "Prices updated successfully!",
};

// Error Messages
export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to fetch products",
  UPDATE_FAILED: "Failed to update prices.",
  EXPORT_FAILED: "Failed to fetch products for export",
};

// Table Headers
export const TABLE_HEADERS = {
  PRODUCT_NAME: "Product Name",
  CATEGORY: "Category",
  SUBCATEGORY: "Subcategory",
  CURRENT_PRICE: "Current Price",
  OFFER_PRICE: "Offer Price",
  NEW_PRICE: "New Price",
  NEW_OFFER_PRICE: "New Offer Price",
};

// Export File Names
export const EXPORT_FILE_NAMES = {
  PRICE_CHANGES: "Price_Change.pdf",
  ALL_PRICES: "All_Prices.pdf",
};

// Search Placeholder
export const SEARCH_PLACEHOLDER =
  "Search products by name, category, or subcategory...";

// Filter Labels
export const FILTER_LABELS = {
  RECENTLY_UPDATED: "Show Recently Updated Only",
};

// Button Labels
export const BUTTON_LABELS = {
  UPDATE_PRICES: "Update Prices",
  EXPORT: "Export",
  EXPORT_CHANGES: "Export Changes",
  EXPORT_ALL: "Export All",
  COMPACT: "Compact",
  DETAILED: "Detailed",
};
